<div>
  <h3 class="textTabsColor mb-4 text-sm font-bold" i18n="@@product.section.productInfo">Product Information</h3>

  @if (!hasSubProducts()) {
    <app-refrigerator-toggale [value]="isRefrigerated()" (toggle)="isRefrigerated.set($event)" />
  }
  <div class="grid grid-cols-1 gap-x-6 gap-y-5 md:grid-cols-2">
    <div class="flex flex-col gap-1.5">
      <label class="labelColorText text-sm font-semibold">
        <span i18n="@@product.field.titleEn">Title (English)</span>
      </label>
      <input
        type="text"
        formControlName="englishName"
        placeholder="Enter product full name in English (optional)"
        i18n-placeholder="@@product.placeholder.titleEn"
        class="focus:borderPrimaryColor w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm transition outline-none focus:ring-2 focus:ring-blue-50"
        [class.bordererrorcolor]="invalid('englishName')" />

      @if (err("englishName", "onlySpaces")) {
        <span class="errortextcolor text-xs" i18n="@@product.validation.titleEnOnlySpaces">
          English title cannot be only spaces
        </span>
      } @else if (err("englishName", "maxlength")) {
        <span class="errortextcolor text-xs" i18n="@@product.validation.titleEnMaxLength">
          English title cannot exceed 255 characters
        </span>
      } @else if (err("englishName", "englishCharacters")) {
        <span class="errortextcolor text-xs" i18n="@@product.validation.shouldBeEnglish">
          English title must contain valid english characters
        </span>
      } @else if (err("englishName", "backendError")) {
        <span class="errortextcolor text-xs">{{ form.get("englishName")?.getError("backendError") }}</span>
      }
    </div>

    <div class="flex flex-col gap-1.5">
      <label class="labelColorText text-sm font-semibold">
        <span i18n="@@product.field.titleAr">Title (Arabic)</span>
        <span class="errortextcolor">*</span>
      </label>
      <input
        type="text"
        formControlName="arabicName"
        placeholder="Enter product full name in Arabic"
        i18n-placeholder="@@product.placeholder.titleAr"
        dir="rtl"
        class="focus:borderPrimaryColor w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm transition outline-none focus:ring-2 focus:ring-blue-50"
        [class.bordererrorcolor]="invalid('arabicName')" />

      @if (err("arabicName", "required")) {
        <span class="errortextcolor text-xs" i18n="@@product.validation.titleArRequired">
          Arabic title is required
        </span>
      } @else if (err("arabicName", "maxlength")) {
        <span class="errortextcolor text-xs" i18n="@@product.validation.titleArMaxLength">
          Arabic title cannot exceed 255 characters
        </span>
      } @else if (err("arabicName", "onlySpaces")) {
        <span class="errortextcolor text-xs" i18n="@@product.validation.titleArOnlySpaces">
          Arabic title cannot be only spaces
        </span>
      } @else if (err("arabicName", "arabicCharacters")) {
        <span class="errortextcolor text-xs" i18n="@@product.validation.shouldBeArabic">
          Must contain valid Arabic characters only
        </span>
      } @else if (err("arabicName", "backendError")) {
        <span class="errortextcolor text-xs">{{ form.get("arabicName")?.getError("backendError") }}</span>
      }
    </div>

    <div class="flex flex-col gap-1.5 md:col-span-2">
      <label class="labelColorText text-sm font-semibold" i18n="@@product.field.descriptionEn">
        Description (English)
      </label>
      <textarea
        formControlName="descriptionEn"
        rows="3"
        placeholder="Enter Description in English"
        i18n-placeholder="@@product.placeholder.descriptionEn"
        class="focus:borderPrimaryColor w-full resize-none rounded-lg border border-gray-200 px-3 py-2.5 text-sm transition outline-none focus:ring-2 focus:ring-blue-50"
        [class.bordererrorcolor]="invalid('descriptionEn')"></textarea>

      @if (err("descriptionEn", "maxlength")) {
        <span class="errortextcolor text-xs" i18n="@@product.validation.descriptionMaxLength">
          Description cannot exceed 2000 characters
        </span>
      } @else if (err("descriptionEn", "englishCharacters")) {
        <span class="errortextcolor text-xs" i18n="@@product.validation.shouldBeEnglishDescription">
          English description must contain valid english characters
        </span>
      }
    </div>

    <div class="flex flex-col gap-1.5 md:col-span-2">
      <label class="labelColorText text-sm font-semibold" i18n="@@product.field.descriptionAr">
        Description (Arabic)
      </label>
      <textarea
        formControlName="descriptionAr"
        rows="3"
        placeholder="Enter Description in Arabic"
        i18n-placeholder="@@product.placeholder.descriptionAr"
        dir="rtl"
        class="focus:borderPrimaryColor w-full resize-none rounded-lg border border-gray-200 px-3 py-2.5 text-sm transition outline-none focus:ring-2 focus:ring-blue-50"
        [class.bordererrorcolor]="invalid('descriptionAr')"></textarea>

      @if (err("descriptionAr", "maxlength")) {
        <span class="errortextcolor text-xs" i18n="@@product.validation.descriptionMaxLength">
          Description cannot exceed 2000 characters
        </span>
      } @else if (err("descriptionAr", "arabicCharacters")) {
        <span class="errortextcolor text-xs" i18n="@@product.validation.shouldBeArabicDescription">
          Arabic description must contain valid arabic characters
        </span>
      }
    </div>

    <div class="flex flex-col gap-1.5">
      <label class="labelColorText text-sm font-semibold">
        <span i18n="@@product.field.mfgCompany">Manufacturing Company</span>
        <span class="errortextcolor">*</span>
      </label>
      <div class="relative">
        <select
          formControlName="mfgCompany"
          class="bgWhiteColor focus:borderPrimaryColor w-full appearance-none rounded-lg border border-gray-200 px-3 py-2.5 text-sm transition outline-none focus:ring-2 focus:ring-blue-50"
          [class.bordererrorcolor]="invalid('mfgCompany')"
          [class.textPlaceholderColor]="!form.get('mfgCompany')?.value"
          [class.pr-3]="!isArabic()"
          [class.pl-8]="!isArabic()"
          [class.pl-3]="isArabic()"
          [class.pr-8]="isArabic()">
          <option value="" disabled selected i18n="@@product.placeholder.selectCompany">Select Company</option>
          @for (company of mfgCompanies(); track company.id) {
            <option [value]="company.id" class="text-gray-900">
              {{ isArabic() ? company.titleAr : company.titleEn }}
            </option>
          }
        </select>
        <app-dropdown-arrow [isArabic]="isArabic()" />
      </div>
      @if (err("mfgCompany", "required")) {
        <span class="errortextcolor text-xs" i18n="@@product.validation.mfgCompanyRequired">
          Manufacturing company is required
        </span>
      }
    </div>

    @if (!hasSubProducts()) {
      <div class="flex flex-col gap-1.5">
        <label class="labelColorText text-sm font-semibold" i18n="@@product.field.category">Category</label>
        <div class="relative">
          <select
            formControlName="category"
            class="bgWhiteColor focus:borderPrimaryColor w-full appearance-none rounded-lg border border-gray-200 px-3 py-2.5 text-sm transition outline-none focus:ring-2 focus:ring-blue-50"
            [class.textPlaceholderColor]="!form.get('category')?.value"
            [class.pr-3]="!isArabic()"
            [class.pl-8]="!isArabic()"
            [class.pl-3]="isArabic()"
            [class.pr-8]="isArabic()">
            <option value="" i18n="@@product.placeholder.selectCategory">Select category</option>
            @for (cat of categories(); track cat.id) {
              <option [value]="cat.id" class="text-gray-900">{{ isArabic() ? cat.titleAr : cat.titleEn }}</option>
            }
          </select>
          <app-dropdown-arrow [isArabic]="isArabic()" />
        </div>
      </div>

      <div class="flex flex-col gap-1.5">
        <label class="labelColorText text-sm font-semibold" i18n="@@product.field.subCategory">Sub Category</label>
        <div class="relative">
          <select
            formControlName="subCategory"
            class="bgWhiteColor focus:borderPrimaryColor w-full appearance-none rounded-lg border border-gray-200 px-3 py-2.5 text-sm transition outline-none focus:ring-2 focus:ring-blue-50"
            [class.textPlaceholderColor]="!form.get('subCategory')?.value"
            [class.pr-3]="!isArabic()"
            [class.pl-8]="!isArabic()"
            [class.pl-3]="isArabic()"
            [class.pr-8]="isArabic()">
            <option value="" i18n="@@product.placeholder.selectSubCategory">Select sub category</option>
            @for (sub of subCategories(); track sub.id) {
              <option [value]="sub.id" class="text-gray-900">{{ isArabic() ? sub.titleAr : sub.titleEn }}</option>
            }
          </select>
          <app-dropdown-arrow [isArabic]="isArabic()" />
        </div>
      </div>

      <div class="flex flex-col gap-1.5">
        <label class="labelColorText text-sm font-semibold" i18n="@@product.field.barcode">Barcode</label>
        <input
          type="text"
          formControlName="barcode"
          maxlength="13"
          placeholder="Enter Product Barcode"
          i18n-placeholder="@@product.placeholder.barcode"
          class="focus:borderPrimaryColor w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm transition outline-none focus:ring-2 focus:ring-blue-50"
          [class.bordererrorcolor]="invalid('barcode')" />

        @if (err("barcode", "minlength") || err("barcode", "maxlength")) {
          <span class="errortextcolor text-xs" i18n="@@product.validation.barcodeLength">
            Barcode should be 13 characters
          </span>
        } @else if (err("barcode", "pattern")) {
          <span class="errortextcolor text-xs" i18n="@@product.validation.barcodeNumeric">
            Barcode must contain only numeric characters
          </span>
        } @else if (err("barcode", "backendError")) {
          <span class="errortextcolor text-xs">{{ form.get("barcode")?.getError("backendError") }}</span>
        }
      </div>
    }
  </div>
</div>
